import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.33333 4.16699L2.5 10.0003M2.5 10.0003L8.33333 15.8337M2.5 10.0003H17.5",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowLeft;
